var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privilegeTreeSelector"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.tree,"show-checkbox":"","node-key":"resource_id","props":_vm.treeProps},on:{"check-change":_vm.checkChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }